import Navbar from './components/Navbar';
import Ticker from './components/Ticker';
import Hero from './components/Hero';
import Categories from './components/Categories';
import Feed from './components/Feed';
import Ranking from './components/Ranking';
import Features from './components/Features';
import About from './components/About';
import Faq from './components/Faq';
import ContactCta from './components/ContactCta';
import Footer from './components/Footer';
import BackToTop from './components/BackToTop';

export default function Home() {
  return (
    <div className="bg-background-50 min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        <div className="pt-16 md:pt-[72px]">
          <Ticker />
        </div>
        <Hero />
        <Categories />
        <Feed />
        <Ranking />
        <Features />
        <About />
        <Faq />
        <ContactCta />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}